module.exports = __webpack_public_path__ + "img/yu_6.16706970.png";